<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { IonContent } from '@ionic/vue';

import { consumeSafetyBrowserHandoff } from '@/modules/safety/composables/useSafetyBrowserHandoff';
import { useAuthStore } from '@/stores/auth/authStore';

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const { t } = useI18n();
const failed = ref(false);

const token = route.params.token?.toString() ?? '';

const normalizeRedirectPath = (redirectPath?: string | null): string => {
	if (!redirectPath || !redirectPath.startsWith('/safety')) {
		return '/safety';
	}

	return redirectPath;
};

onMounted(async () => {
	if (!token) {
		failed.value = true;
		return;
	}

	try {
		const handoff = await consumeSafetyBrowserHandoff(token);
		await authStore.saveToken({ token: handoff.token });
		await router.replace(normalizeRedirectPath(handoff.redirect_path));
	} catch {
		failed.value = true;
	}
});
</script>

<template>
	<ion-content class="ion-padding">
		<div class="min-h-full flex flex-col items-center justify-center text-center text-white px-8">
			<p v-if="!failed" class="text-lg font-semibold">{{ t('safety.browser_handoff.loading') }}</p>

			<div v-else class="flex flex-col items-center gap-4">
				<p class="text-xl font-semibold">{{ t('safety.browser_handoff.failed_title') }}</p>
				<p class="text-base opacity-70">{{ t('safety.browser_handoff.failed_body') }}</p>
				<button class="px-6 py-3 rounded-full bg-white text-black font-semibold" type="button" @click="router.replace('/auth/signinhome')">
					{{ t('safety.browser_handoff.sign_in') }}
				</button>
			</div>
		</div>
	</ion-content>
</template>
